var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2 0H3.8C1.71 0 0 1.71 0 3.8V15.2C0 17.29 1.71 19 3.8 19H15.2C17.29 19 19 17.29 19 15.2V3.8C19 1.71 17.29 0 15.2 0ZM9.5 14.25C6.8875 14.25 4.75 12.1125 4.75 9.5C4.75 6.8875 6.8875 4.75 9.5 4.75C12.1125 4.75 14.25 6.8875 14.25 9.5C14.25 12.1125 12.1125 14.25 9.5 14.25ZM14.725 5.225C14.2025 5.225 13.775 4.7975 13.775 4.275C13.775 3.7525 14.2025 3.325 14.725 3.325C15.2475 3.325 15.675 3.7525 15.675 4.275C15.675 4.7975 15.2475 5.225 14.725 5.225Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/insta.03e7dfd19b5f3b1f796b0da1c6a36507.svg";
export { ForwardRef as ReactComponent };